import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Confirm } from "../../components/confirm";
import { deleteHolding } from "../../services/holding";
import { useLocale } from "../../stores/locale";
import { navigateBack } from "../../utils/navigate-back";

export function HoldingDelete() {
  const navigate = useNavigate();
  const locale = useLocale((state) => state);
  const queryClient = useQueryClient();
  const { id } = useParams();

  if (!id) {
    throw new Error("Holding ID is required");
  }

  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    navigateBack(navigate, "/admin/register/holding");
  };

  return (
    <>
      <Confirm
        header={locale.get("holding.confirmDelete")}
        loading={loading}
        onClose={closeModal}
        onConfirm={() => {
          (async () => {
            setLoading(true);
            try {
              await deleteHolding(id);
              await Promise.all([
                queryClient.invalidateQueries({ queryKey: ["holdings"] }),
                queryClient.invalidateQueries({ queryKey: ["apartments"] }),
              ]);
            } finally {
              setLoading(false);
              closeModal();
            }
          })();
        }}
      />
    </>
  );
}
